import { mapActions, mapState } from 'vuex';

export const roleUserMixins = {
  computed: {
    ...mapState({
      allPmList: (state) => state['account'].allPmList,
      allBdList: (state) => state['account'].allBdList,
      allAmList: (state) => state['account'].allAmList,
    }),
  },
  created() {
    this.getPmList();
    this.getBdList();
    this.getAmList();
  },
  methods: {
    ...mapActions({
      getPmList: 'account/getPmList',
      getBdList: 'account/getBdList',
      getAmList: 'account/getAmList',
    }),
  },
};
